var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadyTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3329 13.7307L47.765 11.6666L30.7872 32.0829L19.0995 22.6884L17 25.2131L31.2495 36.6667L31.4313 36.4481L31.4375 36.4531L50.3329 13.7307Z",
    fill: "#259F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyTeam);
export default __webpack_public_path__ + "static/media/ready_team.ada893228f418c809fcb628942bffdb5.svg";
export { ForwardRef as ReactComponent };